module.exports = __webpack_public_path__ + "static/media/domain3.7376dddb.png";